<template>
  <div class="supplierList">
    <el-card>
      <el-button type="primary" slot="header" @click="jump">{{$t('lang.addsupplierBtn')}}</el-button>
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.supplierListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <!-- <el-table-column prop="id" sortable :label="$t('lang.lab_id')" width="100px"></el-table-column> -->
        <el-table-column prop="name" :label="$t('lang.lab_name')"></el-table-column>
        <el-table-column prop="mobile" :label="$t('lang.lab_telephone')"></el-table-column>
        <el-table-column prop="deadline" :label="$t('lang.lab_cooperation')"></el-table-column>
        <el-table-column
          prop="operation"
          :label="$t('lang.lab_operation')"
          fixed="right"
          :width="require('@/config/enum').opr_width2"
        >
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button
              class="orange"
              @click="deletetable(scope.row.id)"
            >{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="title"
      @closed="handleDialogClosed"
    >
     
        <el-form
          :rules="rules"
          ref="form"
          :model="form"
          :label-width="require('@/config/enum').c_ws5"
          :label-suffix="require('@/config/enum').c_colon"
        >
          <el-form-item :label="$t('lang.lab_suppliername')" prop="name">
            <el-input v-model="form.name" maxlength="20" :placeholder="$t('lang.suppliername')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_telephone')" prop="mobile">
            <el-input v-model="form.mobile" maxlength="15" :placeholder="$t('lang.supplierphone')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_cooperation')" prop="deadline">
            <el-input v-model="form.deadline" maxlength="10" :placeholder="$t('lang.suppliertime')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_remark')" prop="note">
            <el-input v-model="form.note" maxlength="50" :placeholder="$t('lang.supplierremark')"></el-input>
          </el-form-item>
        </el-form>
    
      <div slot="footer">
        <el-button @click="handleDialogClosed()">{{$t('lang.btn_rest')}}</el-button>
        <el-button
          type="primary"
          :disabled="isDisabled"
          @click="onSubmit('form')"
        >{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:supplierList
 *@Description:供应商管理
 *@author:孙斯维
 *@Copyright:格众科技
 *@date:2020-02-21
 */
export default {
  data() {
    var phone = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
    var tel = /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/
    var telephone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_telephone')))
      } else {
        if (!phone.test(value) && !tel.test(value)) {
          callback(new Error(this.$i18n.t('lang.lab_inputDutyPersonPhoneIsTrue')))
        }
        callback()
      }
    }
    return {
      title: this.$i18n.t('lang.modifysupplier'),
      id: '', // 区分新增和修改
      saveData: '', // 存储json字符串
      isDisabled: true, // 确定按钮置灰
      form: {
        name: '',
        mobile: '',
        deadline: '',
        note: ''
      }, // 通过id查询对象
      show: false, // 弹框开关
      multipleSelection: [], // 多选框
      pageCount: 0, // 总页数
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      tableData: [], // 查询list
      supplierListcheckbox: require('@/config/enum').supplierListcheckbox, // 是否隐藏复选框
      rules: {
        name: [
          {
            required: true,
            message: this.$i18n.t('lang.suppliername'),
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            validator: telephone,
            trigger: 'blur'
          }
        ],
        deadline: [
          {
            required: true,
            message: this.$i18n.t('lang.suppliertime'),
            trigger: 'blur'
          }
        ],
        note: [
          {
            required: false,
            message: this.$i18n.t('lang.supplierremark'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.list()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.form.name = ''
      this.form.mobile = ''
      this.form.deadline = ''
      this.form.note = ''
      this.$refs.form.clearValidate()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 供应商列表
    list() {
      let loading = this.$loading()
      this.$get(
        `/suppliers?pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.list()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.list()
    },
    edit(id) {
      this.title = this.$i18n.t('lang.modifysupplier')
      this.id = id
      let loading = this.$loading()
      this.$get(`/suppliersById/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form = res.supplier
            this.saveData = JSON.stringify(this.form)
            this.show = true
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    jump() {
      this.show = true
      this.id = ''
      this.title = this.$i18n.t('lang.addsupplierBtn')
    },
    // 修改保存
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.id === '') {
            let params = {
              Name: this.form.name,
              Mobile: this.form.mobile,
              Deadline: this.form.deadline,
              Note: this.form.note
            }
            let loading = this.$loading()
            this.$postJson(`/suppliers/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.commit()
                  this.show = false
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let loading = this.$loading()
            let params = {
              Name: this.form.name,
              Mobile: this.form.mobile,
              Deadline: this.form.deadline,
              Note: this.form.note
            }
            this.$patch(`/suppliers/${this.id}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(
                    this.$i18n.t('lang.lab_modify_success')
                  )
                  this.commit()
                  this.show = false
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        }
      })
    },
    commit() {
      this.pageNum = 1
      this.list()
    },
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.$delete(`/suppliers/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    }
  }
}
</script>

<style lang="scss">
</style>
